import { getTenantFromSubdomain } from "fe-shared/src/helpers/tenantUtils";

type ApplicationConfig = {
  [key: string]: string;
};

interface WindowWithAppConfig extends Window {
  APP_CONFIG?: ApplicationConfig;
}

const { APP_CONFIG = {} } = window as WindowWithAppConfig;

const DEFAULT_CONFIG: ApplicationConfig = {
  APIGATEWAY_HOST: "https://webappgateway.devmt.{tenant}.esrpapplication.com/",
  IDENTITY_HOST_URL: `https://ids.devmt.esrpapplication.com/`,
  MOBILE_APP_DOWNLOAD_URL: "https://dist-etracks-srp.netlify.app/",
  HELP_PORTAL_URL_PRODUCER: "https://producer-webapp.devmt.esrpapplication.com/",
  HELP_PORTAL_URL_COLLECTOR: "https://collector-webapp.devmt.esrpapplication.com/",
  HELP_PORTAL_URL_PROCESSOR: "https://processor-webapp.devmt.esrpapplication.com/",
  HELP_PORTAL_URL_HAULER: "https://hauler-webapp.devmt.esrpapplication.com/",
  APPLICATIONS_HOST_URL: "http://localhost:4001/",
  TRANSACTIONS_HOST_URL: "http://localhost:4002/",
  REQUESTS_HOST_URL: "http://localhost:4003/",
  REMITTANCES_HOST_URL: "http://localhost:4004/",
  SENTRY_DSN: "",
  ENV: "devmt",
  SENTRY_VERSION: "36.0",
};

/**
 * Gets dynamic API host URL with tenant identifier
 * @param tenantId - optional tenant ID (if not provided, extracted from URL)
 * @returns API host URL with tenant
 */
export const getApiHostUrl = (tenantId?: string): string => {
  const tenant = tenantId || getTenantFromSubdomain();
  if (!tenant) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Unable to determine tenant identifier for API host URL');
    }
    // FOR LOCALHOST TESTING ONLY
    return DEFAULT_CONFIG.APIGATEWAY_HOST.replace('{tenant}', 'etrackson');
  }

  const apiHost = APP_CONFIG.APIGATEWAY_HOST || DEFAULT_CONFIG.APIGATEWAY_HOST;
  return apiHost.replace('{tenant}', tenant);
};

export const getIdentityHostUrl = (): string => APP_CONFIG.IDENTITY_HOST_URL || DEFAULT_CONFIG.IDENTITY_HOST_URL;


export default {
  ...DEFAULT_CONFIG,
  ...APP_CONFIG,
};
